import React from 'react';
import AccurityIcon from '../../../icon/components/AccurityIcon';
import AccurityMenu from '../../../menu/components/AccurityMenu';
var MoreVert = function () { return React.createElement(AccurityIcon, { iconName: "mui:MoreVert" }); };
var DetailMenu = function (_a) {
    var children = _a.children;
    return (React.createElement(React.Fragment, null, React.Children.toArray(children).length > 0 &&
        React.createElement(AccurityMenu, { title: "More options", renderOpenButton: MoreVert, anchorOrigin: {
                vertical: 'top',
                horizontal: 'left',
            }, transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
            } }, children)));
};
export default DetailMenu;
//# sourceMappingURL=DetailMenu.js.map